import { render } from "./PolicyLibraryTable.vue?vue&type=template&id=652f20af&scoped=true"
import script from "./PolicyLibraryTable.vue?vue&type=script&lang=js"
export * from "./PolicyLibraryTable.vue?vue&type=script&lang=js"

import "./PolicyLibraryTable.vue?vue&type=style&index=0&id=652f20af&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652f20af"]])

export default __exports__